module.exports = __webpack_public_path__ + "img/flag-zimbabwe.d81579c9.png";